import { Routes } from '@/config/routes';
import { PaymentGateway } from '@/types';

export const siteSettings = {
  name: 'Tigmoo',
  product: {
    placeholderImage: '/product-placeholder.svg',
  },
  authorizedLinks: [
    { href: Routes.profile, label: 'auth-menu-profile' },
    { href: Routes.orders, label: 'auth-menu-my-orders' },
    { href: Routes.wishlists, label: 'profile-sidebar-my-wishlist' },
  ],
  authorizedLinksMobile: [
    { href: Routes.profile, label: 'auth-menu-profile' },
    { href: Routes.notifyLogs, label: 'profile-sidebar-notifications' },
    { href: Routes.orders, label: 'auth-menu-my-orders' },
    { href: Routes.cards, label: 'profile-sidebar-my-cards' },
    { href: Routes.wishlists, label: 'profile-sidebar-my-wishlist' },
    { href: Routes.questions, label: 'profile-sidebar-my-questions' },
    { href: Routes.refunds, label: 'text-my-refunds' },
    { href: Routes.reports, label: 'profile-sidebar-my-reports' },
    // { href: Routes.checkout, label: 'auth-menu-checkout' },
    { href: Routes.changePassword, label: 'profile-sidebar-password' },
  ],
  dashboardSidebarMenu: [
    {
      href: Routes.profile,
      label: 'profile-sidebar-profile',
    },
    {
      href: Routes.changePassword,
      label: 'profile-sidebar-password',
    },
    {
      href: Routes.notifyLogs,
      label: 'profile-sidebar-notifications',
    },
    {
      href: Routes.cards,
      label: 'profile-sidebar-my-cards',
      // MultiPayment: Make it dynamic or from mapper
      cardsPayment: [PaymentGateway.STRIPE],
    },
    {
      href: Routes.orders,
      label: 'profile-sidebar-orders',
    },
    {
      href: Routes.downloads,
      label: 'profile-sidebar-downloads',
    },
    {
      href: Routes.wishlists,
      label: 'profile-sidebar-my-wishlist',
    },
    {
      href: Routes.questions,
      label: 'profile-sidebar-my-questions',
    },
    {
      href: Routes.refunds,
      label: 'text-my-refunds',
    },
    {
      href: Routes.reports,
      label: 'profile-sidebar-my-reports',
    },
    {
      href: Routes.help,
      label: 'profile-sidebar-help',
    },
    {
      href: Routes.logout,
      label: 'profile-sidebar-logout',
    },
  ],
  headerLinks: [
    { href: Routes.shops, icon: null, label: 'nav-menu-shops' },
    { href: Routes.coupons, icon: null, label: 'nav-menu-offer' },
    { href: Routes.contactUs, label: 'nav-menu-contact' },
    { href: Routes.flashDeal, label: 'nav-menu-flash-deal' },
    { href: Routes.manufacturers, label: 'text-manufacturers' },
    { href: Routes.authors, label: 'text-authors' },
    { href: Routes.help, label: 'nav-menu-faq' },
    { href: Routes.terms, label: 'nav-menu-terms' },
    { href: Routes.customerRefundPolicies, label: 'nav-menu-refund-policy' },
    {
      href: Routes.vendorRefundPolicies,
      label: 'nav-menu-vendor-refund-policy',
    },
  ],
  footer: {
    menus: [
      {
        title: 'text-explore',
        links: [
          {
            name: 'Shops',
            href: Routes.shops,
            target: '_self',
          },
          {
            name: 'Manufacturers',
            href: Routes?.manufacturers,
            target: '_self',
          },
          {
            name: 'Authors',
            href: Routes.authors,
            target: '_self',
          },
          {
            name: 'Flash Deals',
            href: Routes?.flashDeal,
            target: '_self',
          },
          {
            name: 'Offers',
            href: Routes.coupons,
            target: '_self',
          },
          {
            name: 'text-faq-help',
            href: Routes.help,
            target: '_self',
          },
          {
            name: 'text-affiliate',
            href: Routes.affiliate,
            target: '_self',
          },
        ],
      },
      {
        title: 'text-customer-service',
        links: [
          {
            name: 'text-contact-us',
            href: Routes.contactUs,
            target: '_self',
          },
          {
            name: 'Career',
            href: 'https://hrms.tigmoo.com/career/5/en',
            target: '_blank',
          },
          {
            name: 'Privacy policies',
            href: Routes.privacy,
            target: '_self',
          },
          {
            name: 'text-terms-condition',
            href: Routes.terms,
            target: '_self',
          },
          {
            name: 'Vendor Refund Policies',
            href: Routes.vendorRefundPolicies,
            target: '_self',
          },
          {
            name: 'Customer Refund Policies',
            href: Routes.customerRefundPolicies,
            target: '_self',
          },
        ],
      },
      {
        title: 'text-our-information',
        links: [
          {
            name: 'Tigmoo Distribution',
            href: 'https://tigmoobiz.com',
            target: '_blank',
          },
          {
            name: 'Tigmoo Eats',
            href: 'https://www.tigmooeats.com',
            target: '_blank',
          },
          {
            name: 'Tigmoo ShopNShip',
            href: 'https://www.tigmooshopnship.com',
            target: '_blank',
          },
        ],
      },
    ],
  },
};
